import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

export const projectsFoldersDelete = {
  namespaced: true,
  state,
  actions,
  mutations,
}
